<template>
  <div class="footer">
    <!-- 手机版的底部 -->
    <div class="hidden-sm-and-up">
      <ul class="menu-wrap">
        <li v-for="item in list" :key="item.title" class="menu-item">
          <a :href="item.url" class="menu-url" v-if="item.type === 'external'">
            <i class="iconfont" :class="'icon-' + item.icon"></i>
            <p>{{ item.title }}</p>
          </a>
          <router-link :to="item.url" class="menu-url" v-else>
            <i class="iconfont" :class="'icon-' + item.icon"></i>
            <p>{{ item.title }}</p>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 电脑版的底部 -->
    <div class="hidden-xs-only">
      <div class="footer-wrap">
        <div class="container clearfix">
          <p class="info">浙江省杭州市滨江区浦沿路88号</p>
          <p class="info">TEL：0571--86652458（考务/评务） 0571--86612129（考务/咨询）</p>
          <p class="info">浙ICP备05014581号-1 公安备案号33010802005321</p>
          <p class="info">Copyright © mskj.caa.edu.cn 2018 All Rights Reserved.</p>
          <!-- wechat -->
          <div class="wechat-container">
            <div class="text">
              <span>查看手机版</span>
            </div>
            <img src="@/assets/images/wechat.png" class="wechat" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: this.$store.state.tabbar,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  .menu-wrap {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 998;
    display: flex;
    padding-bottom: 0;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    color: #fff;
    background: #222;
    .menu-item {
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;
      font-size: 0;
      text-align: center;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

      .menu-url {
        position: relative;
        height: 50px;
        -webkit-flex-direction: column;
        flex-direction: column;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        .iconfont {
          position: relative;
          display: inline-block;
          margin-top: 10px;
          width: 27px;
          height: 27px;
          color: #fff;
        }
        p {
          position: relative;
          text-align: center;
          font-size: 10px;
          line-height: 1.8;
          color: #fff;
        }
      }

      p {
        // flex: 1;
        color: #eee;
        font-size: 0.55rem;
        white-space: nowrap;
      }
    }
  }
  .footer-wrap {
    width: 100%;
    height: 136px;
    background: #303030;
    position: absolute;
    bottom: 0;
    .container {
      height: 100%;
      .info {
        width: 440px;
        color: #fff;
        font-size: 12px;
        white-space: nowrap;
        margin-top: 39px;
        float: left;
      }
      .wechat-container {
        width: 112px;
        height: 90px;
        background: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        .text {
          width: 22px;
          height: 90px;
          background: #d8010f;
          text-align: center;
          position: relative;
          float: left;
          span {
            color: #fff;
            font-size: 12px;
            line-height: 16px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0.75);
          }
        }
        img {
          width: 90px;
          height: 90px;
          display: block;
          float: right;
        }
      }
    }
  }
}
</style>
